import * as routes from "../data/links/routes";
import { useAuth } from "../context/AuthContext";
import { Navigate, Outlet } from "react-router-dom";

const LoggedRoute = () => {
  let { user } = useAuth();
  return user ? <Navigate to={routes.DASHBOARD} /> : <Outlet />;
};
export default LoggedRoute;
